<div class="d-flex gap-2">
  <div
    class="btn-group btn-group-sm bg-light border border-light-subtle rounded">
    <button
      type="button"
      [disabled]="disabled"
      title="Undo"
      class="btn btn-light fas fa-undo"
      [disabled]="!editor.can().undo()"
      (click)="onUndo()"></button>
    <button
      type="button"
      [disabled]="disabled"
      title="Redo"
      class="btn btn-light fas fa-redo"
      [disabled]="!editor.can().redo()"
      (click)="onRedo()"></button>
    <div class="vr"></div>
    <div ngbDropdown class="d-inline-block styles-dropdown">
      <button
        type="button"
        [disabled]="disabled"
        class="btn btn-light w-100"
        title="Styles"
        ngbDropdownToggle>
        <ng-container [ngSwitch]="true">
          <ng-container *ngSwitchDefault>Normal text</ng-container>
          <ng-container
            *ngSwitchCase="editor.isActive('heading', { level: 1 })">
            Heading 1
          </ng-container>
          <ng-container
            *ngSwitchCase="editor.isActive('heading', { level: 2 })">
            Heading 2
          </ng-container>
          <ng-container
            *ngSwitchCase="editor.isActive('heading', { level: 3 })">
            Heading 3
          </ng-container>
        </ng-container>
      </button>
      <div class="border border-light-subtle shadow-sm" ngbDropdownMenu>
        <button
          type="button"
          [disabled]="disabled"
          title="Normal text"
          ngbDropdownItem
          [class.active]="editor.isActive('paragraph')"
          (click)="editor.chain().focus().setParagraph().run()">
          Normal text
        </button>
        <button
          type="button"
          [disabled]="disabled"
          title="Heading 1"
          ngbDropdownItem
          [class.active]="editor.isActive('heading', { level: 1 })"
          (click)="editor.chain().focus().setHeading({ level: 1 }).run()">
          Heading 1
        </button>
        <button
          type="button"
          [disabled]="disabled"
          title="Heading 2"
          ngbDropdownItem
          [class.active]="editor.isActive('heading', { level: 2 })"
          (click)="editor.chain().focus().setHeading({ level: 2 }).run()">
          Heading 2
        </button>
        <!-- <button
          type="button"
          [disabled]="disabled"
          title="Heading 3"
          ngbDropdownItem
          [class.active]="editor.isActive('heading', { level: 3 })"
          (click)="editor.chain().focus().setHeading({ level: 3 }).run()">
          Heading 3
        </button> -->
      </div>
    </div>
    <!-- <div class="vr"></div>
    <button
      type="button"
      [disabled]="disabled"
      title="Bold"
      class="btn btn-light ms-0 fas fa-bold"
      [class.active]="editor.isActive('bold')"
      (click)="editor.chain().focus().toggleBold().run()"></button>
    <button
      type="button"
      [disabled]="disabled"
      title="Italic"
      class="btn btn-light fas fa-italic"
      [class.active]="editor.isActive('italic')"
      (click)="editor.chain().focus().toggleItalic().run()"></button>
    <div class="vr"></div>
    <button
      type="button"
      [disabled]="disabled"
      title="Bullet list"
      class="btn btn-light ms-0 fas fa-list-ul"
      [class.active]="editor.isActive('bulletList')"
      (click)="editor.chain().focus().toggleBulletList().run()"></button>
    <button
      type="button"
      [disabled]="disabled"
      title="Ordered list"
      class="btn btn-light fas fa-list-ol"
      [class.active]="editor.isActive('orderedList')"
      (click)="editor.chain().focus().toggleOrderedList().run()"></button> -->
  </div>
  <!-- <app-tiptap-export-menu [editor]="editor"></app-tiptap-export-menu> -->
</div>
